// Returns prefix URL on the browser and empty string on the server.
export function getPrefixURL() {
  return typeof window !== "undefined" ? window?.location?.origin || "" : "";
}
